<template>
  <div>
    <div id="hello" class="hello section">
      <div class="left col">
        <div class="content">
          Get insights from your social marketing campaigns.
          Try <i>1000 images for free</i>.<br><br>
          <div class="button" v-on:click="analyze('marketing')">Analyze your images</div>
        </div>
      </div>
      <div class="right col">
      </div>
    </div>
    <div id="influencer" class="influencer section">
      <div class="left col">

      </div>
      <div class="right col">
        <div class="content">
          Screen influencers with our brand safety check.
          Analyze <i>100 influencers for free</i>.<br><br>
          <div class="button" v-on:click="analyze('influencers')">Screen influencers</div>
        </div>
      </div>
    </div>
    <div id="company" class="company section">
      <div class="left col">
        <div class="content">
          Analyze your companies image bank and gain insights into how well they convey your brand.
          Try <i>1000 images for free</i>.<br><br>
          <div class="button" v-on:click="analyze('branding')">Analyze your images</div>
        </div>
      </div>
      <div class="right col">
      </div>
    </div>
    <div id="what-we-do" class="what-we-do section">
      <div>
        At Photo AI we work with the best artificial intelligence technologies in the world. We use insights from these technologies to create <i>real value</i> for companies. Our core is to give valuable insights from large sets of images.<br><br>
        <div class="small">
          - Derek Hols, Founder & CEO
      </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TempAna',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      flickityOptions: {
        initialIndex: 3,
        prevNextButtons: false,
        pageDots: false,
        wrapAround: true
      }
    }
  },
  methods: {
    analyze (what) {
      if (window.gtag) {
        window.gtag('event', 'clicked', {
          'event_label': what
        })
      }
      this.$emit('clicked')
    }
  },
  components: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .hello {

  }
  .hello .right {
    background-image: url('./../assets/back-large2-min.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: auto 90%;
    background-color: #fff;    
  }
  .influencer .left {
    background-image: url('./../assets/back2-min.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: auto 70%;
    background-color: #fff; 
  }
  .company .right {
    background-image: url('./../assets/corp-min.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: auto 70%;
    background-color: #fff;    
  }
  .what-we-do {
    max-width: 900px;
    width: 90%;
    margin: auto;
    min-height: 50vh;
    font-size: 3vh;
  }
  .small {
    font-size: 18px;
  }
  i {
    display: inline;
    border-bottom: 3px dashed #f1f1f1;
  }
</style>



// WEBPACK FOOTER //
// src/components/TempAna.vue